const images = [];
export default  function preload(url_list) {
  if (!url_list) {
    return;
  }
  for (let i = 0; i < url_list.length; i++) {
    images[i] = new Image();
    images[i].src = url_list[i];
  }
}



// WEBPACK FOOTER //
// ./src/tools/preload.js